import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';

export const PvDropdownMenu = DropdownMenuPrimitive.Root;
